"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BgLocalIncrementIntComponentParameters = void 0;
exports.BgLocalIncrementIntComponentParameters = [
    {
        id: 'initial',
        label: 'Initial Value',
        description: 'Input Param - Optional initial integer value to start with',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'step',
        label: 'Step Value',
        description: 'Input Param - Optional step by which to increment the integer',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'output',
        label: 'Output Value',
        description: 'Output Param - The resulting integer after increment',
        type: 'output',
        paramType: 'INT',
        required: true,
    },
];
//# sourceMappingURL=BgLocalIncrementIntComponent.js.map